import React, { useEffect } from 'react';
import SEO from '../components/SEO';
import DiscordSection from '../components/DiscordSection';

const Story = () => {
  useEffect(() => {
    // Animation for chapter reveals
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1 });

    const chapters = document.querySelectorAll('.chapter');
    chapters.forEach(chapter => observer.observe(chapter));

    return () => {
      chapters.forEach(chapter => observer.unobserve(chapter));
    };
  }, []);

  return (
    <div className="story-page">
      <SEO 
        title="L'Histoire Complète d'Ultraze FA | Récit Authentique FiveM | ultraze.fr"
        description="L'histoire complète d'Ultraze FA racontée par BLF. Découvrez le parcours de création de serveurs FiveM, les collaborations, les défis et la naissance de SideLife. Un récit captivant de passion gaming et d'aventures humaines dans l'univers GTA RP."
        keywords="histoire ultraze fa, récit fivem, blf histoire, création serveur fivem, side life histoire, ultraze fa story, fivem rp histoire, gaming story, histoire serveur gta, récit gaming français, communauté fivem histoire, développement serveur rp, expérience fivem, parcours gaming, histoire communautaire gaming, ultraze fa chronologie, évolution fivem, side life création, histoire vraie fivem, récit authentique gaming"
        url="/histoire"
        image="/logo.png"
        type="article"
      />
      <section className="story-content">
        <div className="container">
          <h2 className="section-title">L'HISTOIRE <span className="highlight">COMPLÈTE</span></h2>
          


          <div className="detailed-story">
            <div className="chapter">
              <div className="chapter-header">
                <span className="chapter-number">01</span>
                <h3>Le Début d'une Aventure</h3>
              </div>
              <div className="chapter-content">
                <p>
                  Si tu lis ce message aujourd'hui, ce n'est pas une annonce classique. 
                  Ce n'est ni un drama, ni une justification. C'est simplement le récit d'une histoire, 
                  racontée avec le cœur, dans un cadre volontairement imaginaire.
                </p>
                <p>
                  Imaginons une personne, appelons-la BLF. Dans ce récit, BLF serait une personne 
                  passionnée par FiveM, qui y aurait investi du temps, de l'énergie, de l'argent, 
                  mais surtout des relations humaines.
                </p>
              </div>
            </div>

            <div className="chapter">
              <div className="chapter-header">
                <span className="chapter-number">02</span>
                <h3>Les Projets Fondateurs</h3>
              </div>
              <div className="chapter-content">
                <p>
                  Quelqu'un qui aurait monté plusieurs projets, pensés avant tout comme des aventures 
                  humaines, construites avec sérieux et engagement. Des équipes soudées, des relations 
                  de confiance, et une vision commune auraient marqué cette période.
                </p>
              </div>
            </div>

            <div className="chapter">
              <div className="chapter-header">
                <span className="chapter-number">03</span>
                <h3>Une Nouvelle Collaboration</h3>
              </div>
              <div className="chapter-content">
                <p>
                  Dans ce scénario, BLF aurait décidé de tenter une nouvelle collaboration avec une 
                  autre entité du milieu. Une collaboration qui, sur le papier, semblait prometteuse 
                  et appréciée des joueurs.
                </p>
                <p>
                  Mais très tôt dans cette histoire, des tensions seraient apparues en coulisse. 
                  Certaines décisions auraient été prises rapidement, laissant le projet sans l'équipe 
                  initialement prévue.
                </p>
              </div>
            </div>

            <div className="chapter">
              <div className="chapter-header">
                <span className="chapter-number">04</span>
                <h3>L'Engagement Malgré Tout</h3>
              </div>
              <div className="chapter-content">
                <p>
                  Alors même que tout venait à peine de commencer, l'équipe de BLF aurait continué, 
                  portée par la passion et le respect des joueurs. Malgré cela, on pourrait imaginer 
                  que l'équipe proche de BLF aurait continué à s'investir pleinement.
                </p>
                <p>
                  Les bases de l'accord, dans cette histoire, auraient été relativement simples : 
                  une répartition claire des rôles, un partage théorique des responsabilités financières, 
                  et une gestion de la visibilité confiée à une autre partie.
                </p>
              </div>
            </div>

            <div className="chapter">
              <div className="chapter-header">
                <span className="chapter-number">05</span>
                <h3>Les Difficultés Émergentes</h3>
              </div>
              <div className="chapter-content">
                <p>
                  Dans les faits du récit, cette communication aurait pu rester irrégulière, 
                  malgré des intentions affichées. Par ailleurs, un autre projet, distinct 
                  mais lié par son environnement, aurait pris de plus en plus de place.
                </p>
                <p>
                  Dans cette configuration fictive, des divergences de vision auraient 
                  naturellement émergé. Certaines orientations auraient été discutées, 
                  parfois refusées, non par opposition personnelle, mais par volonté 
                  de préserver une cohérence interne.
                </p>
              </div>
            </div>

            <div className="chapter">
              <div className="chapter-header">
                <span className="chapter-number">06</span>
                <h3>Le Choix Difficile</h3>
              </div>
              <div className="chapter-content">
                <p>
                  Ces désaccords, tels qu'ils pourraient être racontés dans cette histoire, 
                  auraient eu des conséquences humaines : des collaborations interrompues, 
                  des relations mises à distance, et une ambiance de travail dégradée.
                </p>
                <p>
                  Arrivé à ce point du récit, BLF aurait été confronté à un choix difficile, 
                  mais clair dans son principe : continuer au prix de concessions humaines importantes, 
                  ou rester fidèle à une équipe qu'il considérait avant tout comme des individus.
                </p>
              </div>
            </div>

            <div className="chapter">
              <div className="chapter-header">
                <span className="chapter-number">07</span>
                <h3>Le Nouveau Départ</h3>
              </div>
              <div className="chapter-content">
                <p>
                  Dans cette histoire, le choix aurait été fait avec calme, 
                  sans chercher de responsable unique. C'est alors qu'aurait émergé l'idée 
                  de relancer un projet plus ancien, mis en pause mais jamais totalement abandonné.
                </p>
                <p>
                  Ce projet, dans ce récit, aurait été repensé comme un nouveau départ, 
                  avec plus de recul, plus d'expérience, et une attention particulière 
                  portée aux valeurs humaines.
                </p>
              </div>
            </div>

            <div className="chapter">
              <div className="chapter-header">
                <span className="chapter-number">08</span>
                <h3>Les Promesses Évaporées</h3>
              </div>
              <div className="chapter-content">
                <p>
                  Parallèlement, toujours dans cette construction narrative, 
                  des discussions financières auraient existé. Des engagements auraient été évoqués, 
                  puis modifiés, voire réinterprétés.
                </p>
                <p>
                  Sans entrer dans des détails qui n'auraient de toute façon pas leur place ici, 
                  cette partie de l'histoire se serait conclue par la fin d'une collaboration 
                  devenue trop fragile.
                </p>
              </div>
            </div>

            <div className="chapter">
              <div className="chapter-header">
                <span className="chapter-number">09</span>
                <h3>Prévention et Protection</h3>
              </div>
              <div className="chapter-content">
                <p>
                  On pourrait également imaginer que certaines mesures préventives 
                  auraient été prises. Des outils techniques auraient été mis en place, 
                  non pour contraindre ou récupérer qui que ce soit, mais comme une forme d'assurance.
                </p>
                <p>
                  Celle de ne pas perdre le lien avec des personnes en cas d'arrêt brutal d'un projet.
                </p>
              </div>
            </div>

            <div className="chapter final-chapter">
              <div className="chapter-header">
                <span className="chapter-number">10</span>
                <h3>La Continuité Logique</h3>
              </div>
              <div className="chapter-content">
                <p>
                  Aujourd'hui, dans cette histoire hypothétique, le projet relancé ne représenterait 
                  ni une revanche, ni une réponse directe à des événements passés. 
                  Il serait simplement la continuité logique d'un parcours.
                </p>
                <p>
                  Un chapitre de plus, écrit avec davantage de lucidité et de prudence.
                </p>
                <p className="conclusion-text">
                  Libre à chacun d'y voir ce qu'il souhaite y voir.
                </p>
                <p className="signature">
                  — BLF | SideLife
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <DiscordSection />
    </div>
  );
};

export default Story;